import { useAppSelector } from '@/hooks/redux'
import { licenceSelectors } from '@/redux/reducers/licence'
import { ILicence } from '@/types/licence'
import invariant from 'tiny-invariant'

export const useLicence = (): ILicence => {
    const licence = useAppSelector(licenceSelectors.licence)

    invariant(licence, 'licence must be set')

    return licence
}
